import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline'
import { CardContent, Divider, Paper, Stack, Typography } from '@mui/material'
import { FC } from 'react'
import { generatePath, useNavigate } from 'react-router-dom'

import { AppRoutes } from '../../models'
import { InspectionEntry } from '../../sdk'
import { InspectionStatusSelect } from '../Inspections/InspectionStatusSelect'
import { ClickableCard } from '../SharedUI/ClickableCard'
import AddInspectionButton from './AddInspectionButton'

interface Props {
  repairOrderId: string
  inspections: InspectionEntry[] | undefined
  isDvi?: boolean
}

// this component is shared between main app and dvi single job, both use RepairOrderContext
const InspectionsPanel: FC<Props> = ({ repairOrderId, inspections, isDvi }) => {
  const navigate = useNavigate()
  return (
    <>
      <Paper
        variant="outlined"
        sx={{
          p: 2
        }}>
        <Stack direction="row" justifyContent={'space-between'}>
          <Typography component="h4" variant="h4">
            Inspections
          </Typography>

          <AddInspectionButton
            variant="text"
            startIcon={<AddCircleOutlineIcon />}
            repairOrderId={repairOrderId}>
            Add
          </AddInspectionButton>
        </Stack>
        <Divider />
        {inspections && inspections?.length !== 0 ? (
          <Stack spacing={1} my={1}>
            {inspections.map((inspection) => (
              <ClickableCard
                key={inspection.id!}
                onClick={() =>
                  navigate(
                    isDvi
                      ? generatePath(AppRoutes.DVI_SINGLE_INSPECTION_SUMMARY, {
                          id: inspection.id!
                        })
                      : generatePath(AppRoutes.SINGLE_INSPECTION, {
                          id: inspection.id!
                        })
                  )
                }>
                <CardContent sx={{ padding: '8px' }}>
                  <Stack
                    direction="row"
                    justifyContent={'space-between'}
                    alignItems={'center'}>
                    <Typography>{inspection.info!.title}</Typography>
                    <InspectionStatusSelect
                      inspection={inspection}
                      isChip
                      readOnly={!!isDvi}
                    />
                  </Stack>
                </CardContent>
              </ClickableCard>
            ))}
          </Stack>
        ) : (
          <AddInspectionButton
            variant="text"
            startIcon={<AddCircleOutlineIcon />}
            repairOrderId={repairOrderId}
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              background: 'rgba(0, 0, 0, 0.24)',
              border: '1px dotted black',
              borderRadius: 1,
              marginTop: 2,
              width: '100%',
              '&:hover': {
                backgroundColor: 'rgba(0, 0, 0, 0.24)'
              }
            }}>
            Click here to start inspection
          </AddInspectionButton>
        )}
      </Paper>
    </>
  )
}

export default InspectionsPanel
